import { RdsServer, RdsCatalog, RdsDataProduct } from '@rds/sdk';
import { years } from './years';

const server = new RdsServer(process.env.REACT_APP_RDS_SERVER);

export async function rdsSelect(catalog, dataProduct, config, useCache = false, wave = years.rdsWave) {
  const cache = window.sessionStorage;
  const key = `rdsSelect-${catalog}${dataProduct}${JSON.stringify(config)}${wave}`.hashCode(); // hash key for the cache

  if (useCache && cache.getItem(key)) {
    const d = cache.getItem(key);
    return JSON.parse(d);
  }

  const c = new RdsCatalog(server, catalog);
  const d = new RdsDataProduct(c, dataProduct);
  const updatedConfig = { ...config };
  if (catalog === 'ccdc' && wave) { // wave can be unset by the covid story
    updatedConfig.where += ` AND wave_id=${wave}`;
  }
  updatedConfig.limit = 10000;
  const result = await d.select(updatedConfig);
  cache.setItem(key, JSON.stringify(result));
  return result;
}

export async function rdsTabulate(catalog, dataProduct, config, useCache = false, wave = years.rdsWave) {
  const cache = window.sessionStorage;
  const key = `rdsTabulate-${catalog}${dataProduct}${JSON.stringify(config)}${wave}`.hashCode(); // hash key for the cache

  if (useCache && cache.getItem(key)) {
    const d = cache.getItem(key);
    return JSON.parse(d);
  }

  const c = new RdsCatalog(server, catalog);
  const d = new RdsDataProduct(c, dataProduct);
  const updatedConfig = { ...config };
  updatedConfig.limit = 10000;
  if (catalog === 'ccdc' && wave) { // wave can be unset by the covid story
    updatedConfig.where += ` AND wave_id=${wave}`;
  }
  const result = await d.tabulate(updatedConfig);
  cache.setItem(key, JSON.stringify(result));
  return result;
}
